import axios from "axios";

// 查询当前单位已配置的下游系统，用于渲染同步管理筛选项和配置页签。
export const getDownstreamSyncConfigs = params => {
  return axios.request({
    url: "/api/sync/downstream/configs",
    method: "get",
    params
  });
};

// 一键生成 webhook 订阅与同步配置，自动获取按钮直接使用文档推荐流程。
export const oneClickDownstreamSyncConfig = data => {
  return axios.request({
    url: "/api/sync/downstream/config/one-click",
    method: "post",
    data
  });
};

// 保存下游同步配置，只提交文档允许编辑的基础字段。
export const saveDownstreamSyncConfig = data => {
  return axios.request({
    url: "/api/sync/downstream/config",
    method: "post",
    data
  });
};

// 按后端真实探活接口测试 webhook 推送地址和下游主动查询根地址。
// config 用于静默探活等场景，避免页面初始化时重复弹出全局错误提示。
export const testDownstreamConnection = (data, config = {}) => {
  return axios.request({
    url: "/api/sync/downstream/test-connection",
    method: "post",
    data,
    ...config
  });
};

// 查询同步总览状态，页面初始化只读取状态，不触发任何同步操作。
export const getDownstreamOverview = data => {
  return axios.request({
    url: "/api/sync/downstream/overview",
    method: "post",
    data
  });
};

// 查询成员在各下游系统的业务账号回传状态；角标预取可通过 config 关闭全局提示。
export const getDownstreamAccountsPage = (data, config = {}) => {
  return axios.request({
    url: "/api/sync/downstream/accounts/page",
    method: "post",
    data,
    ...config
  });
};

// 查询需要人工处理的同步告警，不在查询阶段处理告警。
export const getDownstreamAlertsPage = data => {
  return axios.request({
    url: "/api/sync/downstream/alerts/page",
    method: "post",
    data
  });
};

// 查询 webhook 投递日志，用于排查下游回调和投递状态。
export const getDownstreamLogsPage = data => {
  return axios.request({
    url: "/api/sync/downstream/logs/page",
    method: "post",
    data
  });
};

// 查看 webhook 请求 Payload；详情弹窗自己展示错误文案，因此这里关闭全局重复 toast。
export const getDownstreamLogDetail = data => {
  return axios.request({
    url: "/api/sync/downstream/logs/detail",
    method: "post",
    data,
    headers: {
      nomsg: true
    }
  });
};

// 显式触发账号重推；结果由页面统一汇总提示，避免拦截器再弹一次失败信息。
export const repushDownstreamAccounts = data => {
  return axios.request({
    url: "/api/sync/downstream/accounts/repush",
    method: "post",
    data,
    headers: {
      nomsg: true
    }
  });
};

// 显式触发补偿查询；页面会按操作结果统一提示，保留一次 toast 即可。
export const compensateDownstreamAccounts = data => {
  return axios.request({
    url: "/api/sync/downstream/accounts/compensate",
    method: "post",
    data,
    headers: {
      nomsg: true
    }
  });
};

// 仅查询候选账号，人工绑定确认由 manual-bind 接口单独完成。
export const getDownstreamAlertCandidates = data => {
  return axios.request({
    url: "/api/sync/downstream/alerts/candidates",
    method: "post",
    data
  });
};

// 提交管理员选择的候选账号；成功失败都由页内操作结果统一提示。
export const manualBindDownstreamAlert = data => {
  return axios.request({
    url: "/api/sync/downstream/alerts/manual-bind",
    method: "post",
    data,
    headers: {
      nomsg: true
    }
  });
};